module.exports = __webpack_public_path__ + "static/Welcome Replacement-dfc49c65fd5d13946e65a94c8e45a005.png";